import React, { useEffect } from "react";

import AOS from "aos";
import "aos/dist/aos.css";

import {
  FaSchool,
  FaUsers,
  FaBookOpen,
  FaChalkboardTeacher,
} from "react-icons/fa";


import mainClassImage from "./class6.jpg";

import classroomOne from "./class1.jpg";
import classroomTwo from "./class2.jpg";
import classroomThree from "./class3.jpg";
import classroomFour from "./class4.jpg";


import "./HomeSlide.css";



const galleryItems = [

  {
    image: classroomOne,
    icon:<FaSchool />,
    title:"Modern Classrooms",
    description:
    "Our classrooms are designed to provide a comfortable and inspiring environment where students can learn effectively.",
  },


  {
    image: classroomTwo,
    icon:<FaUsers />,
    title:"Student Community",
    description:
    "We encourage teamwork, friendships, and collaboration that help students develop confidence and leadership skills.",
  },


  {
    image: classroomThree,
    icon:<FaBookOpen />,
    title:"Creative Learning",
    description:
    "Students experience engaging lessons that promote curiosity, creativity, and academic excellence.",
  },


  {
    image: classroomFour,
    icon:<FaChalkboardTeacher />,
    title:"Professional Teaching",
    description:
    "Our dedicated teachers guide students through quality instruction and personalized support.",
  },


];




const HomeSlide = () => {


useEffect(()=>{

    AOS.init({
        duration:1000,
        once:true,
    });

},[]);




return (

<section className="school-gallery-section">


    <div className="school-gallery-wrapper">



        {/* LEFT FEATURE IMAGE */}


        <div
        className="school-gallery-main"
        data-aos="fade-right"
        >


            <img
            src={mainClassImage}
            alt="School Classroom"
            />


            <div className="school-gallery-overlay">


                <h2>
                    Inspiring Learning
                    <span>
                    Environment
                    </span>
                </h2>


                <p>
                    Creating a place where students
                    discover knowledge, develop skills,
                    and build their future.
                </p>


            </div>


        </div>





        {/* RIGHT CARDS */}



        <div className="school-gallery-grid">


        {
            galleryItems.map((item,index)=>(


                <div
                className="school-gallery-card"
                key={item.title}
                data-aos="fade-up"
                data-aos-delay={index*200}
                >



                    <div className="school-gallery-image">


                        <img
                        src={item.image}
                        alt={item.title}
                        />


                        <div className="school-gallery-icon">

                            {item.icon}

                        </div>


                    </div>




                    <div className="school-gallery-content">


                        <h3>
                            {item.title}
                        </h3>


                        <p>
                            {item.description}
                        </p>


                    </div>



                </div>



            ))
        }



        </div>



    </div>


</section>

);


};


export default HomeSlide;